import { create } from 'zustand';

export type PublicSearchScope = 'courses' | 'sports' | 'events';

type PublicSearchQueries = Record<PublicSearchScope, string>;

interface PublicSearchState {
  queries: PublicSearchQueries;
  setQuery: (scope: PublicSearchScope, query: string) => void;
}

const initialQueries: PublicSearchQueries = {
  courses: '',
  sports: '',
  events: '',
};

export const usePublicSearchStore = create<PublicSearchState>((set) => ({
  queries: initialQueries,
  setQuery: (scope, query) =>
    set((state) => {
      if (state.queries[scope] === query) {
        return state;
      }

      return {
        queries: {
          ...state.queries,
          [scope]: query,
        },
      };
    }),
}));
